import styled from 'styled-components';
import { PARAMS } from '../../services/Player';
import Select from '../Select';
import Search from './Search';
import mixpanel from 'mixpanel-browser';
import Button from '../Button';
import SplitIOTreatment from '../../../components/splitio/splitioTreatment';
import splitsDictionary from '../../../services/utils/splitsDictionary';

const ADD_PLAYER_CLICK_EVENT_NAME = 'Therapy_RestoreSkillsUI_MyPlayers_Click';

const AddPlayerButton = styled(Button)`
  margin-left: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
`;

const PlusIcon = styled.span(({ theme }) => {
  return `
    margin-right: 15px;
    font-size: ${theme.type.size.larger};
  `;
});

const Title = styled.h1(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.larger};
    font-weight: ${type.weight.black};
    color: ${color.grayscale[0]};
    text-align: center;
    margin-bottom: 2rem;
  `;
});

const ViewAll = styled.button(({ theme }) => {
  const { color, type } = theme;

  return `
    color: ${color.grayscale[0]}; 
    font-weight: ${type.weight.bold};
    border: 0;
    font-size: ${type.size.small};
  `;
});

const Divider = styled.span(({ theme }) => {
  const { color, type } = theme;

  return `
    color: ${color.grayscale[0]};
    font-size: ${type.size.regular};
    padding: 0 1rem;
  `;
});

const Inputs = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  gap: 2rem;
  align-items: center;
`;

const RightContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
`;

const Header = ({ params, handleParamChange, total, openAddPlayerDialog }) => {
  const updateFields = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (name === 'sort') {
      const sort = value.split('_');
      handleParamChange({ ...params, [PARAMS.SORT_BY]: sort[0], [PARAMS.SORT_DIRECTION]: sort[1] });
    } else {
      handleParamChange({ ...params, [name]: value });
    }
  };

  const clearFilters = () => {
    handleParamChange({ ...params, [PARAMS.NAME]: '', [PARAMS.DATE_FROM]: '', [PARAMS.DATE_TO]: '' });
  };

  return (
    <section>
      <Title>My Players</Title>

      <Container>
        {params[PARAMS.NAME] && total > 0 && (
          <>
            <ViewAll onClick={clearFilters}>View All</ViewAll>

            <Divider>|</Divider>
          </>
        )}

        <Inputs>
          {/* <Date
            name={PARAMS.DATE_FROM}
            label="Active from:"
            value={params[PARAMS.DATE_FROM]}
            shadow={true}
            callback={updateFields}
            max={params[PARAMS.DATE_TO]}
          />
          <Date
            name={PARAMS.DATE_TO}
            label="Active to:"
            value={params[PARAMS.DATE_TO]}
            shadow={true}
            callback={updateFields}
            min={params[PARAMS.DATE_FROM]}
          /> */}
          <Select
            name="sort"
            label="Sort by:"
            options={[
              { value: 'alpha_1', display: 'Name Ascending' },
              { value: 'alpha_0', display: 'Name Descending' },
              // { value: 'date_1', display: 'Date Ascending' },
              // { value: 'date_0', display: 'Date Descending' },
            ]}
            shadow={true}
            callback={updateFields}
            value={`${params[PARAMS.SORT_BY]}_${params[PARAMS.SORT_DIRECTION]}`}
          />
        </Inputs>

        <RightContainer>
          <Search callback={updateFields} value={params[PARAMS.NAME]} name={PARAMS.NAME} />

          <SplitIOTreatment
            featureName={splitsDictionary.ADD_PLAYER.name}
            trafficType={splitsDictionary.ADD_PLAYER.traffic_type}
            treatmentValue="on"
          >
            {(treatment) => {
              if (treatment === 'on') {
                return (
                  <AddPlayerButton
                    rounded={true}
                    onClick={() => {
                      openAddPlayerDialog();
                      mixpanel.track(ADD_PLAYER_CLICK_EVENT_NAME, {
                        Action: 'AddAPlayer',
                      });
                    }}
                  >
                    <PlusIcon>+</PlusIcon> <span>Add New Player</span>
                  </AddPlayerButton>
                );
              } else {
                return null;
              }
            }}
          </SplitIOTreatment>
        </RightContainer>
      </Container>
    </section>
  );
};

export default Header;
